import o from"styled-components";const e=o.aside`
	display: flex;
	flex-direction: column;
	gap: 24px;
	border-right: 1px solid rgba(0, 0, 0, 0.1);
	box-shadow: 4px 0px 10px 0px rgba(0, 0, 0, 0.04);
	padding: 24px 16px;
	box-sizing: border-box;
	position: relative;
	height: calc(100vh - 75px);
	background-color: ${({theme:o})=>o.bg.primary};
`,r=o.div`
	display: flex;
	min-height: 96px;
	background-color: ${({isActiveBlock:o})=>o?"rgba(0, 175, 255, 0.15)":"transparent"};
	border-radius: 6px;
	gap: 8px;
	padding: 8px;
	cursor: pointer;
	user-select: none;
	&.draggable-mirror {
		width: 207px;
	}
`,i=o.div`
	display: flex;
	align-items: center;
	gap: 4px;

	& > span {
		font-family: "PP Formula";
		padding-top: 2px;
	}
`,t=o.div`
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	height: 100%;
	gap: 8px;
	&.draggable-container--is-dragging,
	&.draggable-container--is-dragging * {
		cursor: grabbing !important;
	}
`,p=o.span`
	color: ${({isActiveBlock:o})=>o?"#00afff":"#C5C5C5"};
	font-size: 16px;
	font-weight: 500;
	cursor: grab;
`,n=o.div`
	border-radius: 4px;
	border: 0.3px solid ${({theme:o})=>o.border.black10};
	background-color: ${({theme:o})=>o.bg.primary};
	flex: 1;
`,d=o.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	width: ${({width:o="370px"})=>o};
	background-color: ${({theme:o})=>o.bg.general};
	left: 100%;
	inset-block: 0;
	z-index: 20;
	border-left: 1px solid rgba(0, 0, 0, 0.1);
	border-right: 1px solid rgba(0, 0, 0, 0.1);
	box-shadow: 4px 0px 10px 0px rgba(0, 0, 0, 0.04);
	box-sizing: border-box;
	height: 100%;
`,a=o.div`
	display: flex;
	gap: 8px;
	padding: 24px;
	position: relative;
`,x=o.button`
	display: grid;
	place-content: center;
	width: 24px;
	height: 24px;
	font-size: 18px;
	font-weight: 400;
	color: ${({theme:o})=>o.text.title};
	background: none;
	border: none;
	cursor: pointer;
	margin-top: -4px;
`,l=o.h1`
	font-family: "PP Formula";
	font-size: 16px;
	color: ${({theme:o})=>o.text.text};
	font-weight: 400;
	margin: 0;
`,s=o.div`
	display: flex;
	flex-direction: column;
	gap: ${({gap:o="8px"})=>o};
	padding: 16px 24px;
	overflow-y: auto;
	flex: 1;
`,g=o.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;o.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;const c=o.h1`
	margin: 0;
	font-size: 14px;
	font-weight: 700;
	color: ${({theme:o})=>o.text.text};
	padding-bottom: 12px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;o.span`
	color: ${({theme:o})=>o.border.brand};
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	cursor: pointer;
`;const b=o.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	column-gap: 16px;
	row-gap: 24px;
`,h=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	cursor: pointer;
	position: relative;

	&:hover {
		& > div {
			display: grid;
		}
	}
`,f=o.div`
	display: none;
	place-content: center;
	inset: 0;
	position: absolute;
	z-index: 10;
	padding-top: 15px;
	width: 200px;
	height: 111.55px;
	background-color: rgba(0, 0, 0, 0.3);
	margin-top: 22px;
	border-radius: 3px;
	box-sizing: border-box;
`,m=o.button`
	padding: 8px 16px;
	color: ${({theme:o})=>o.text.inverse};
	border-radius: 9999px;
	font-size: 12px;
	background-color: ${({theme:o})=>o.border.brand};
	z-index: 20;
	border: none;
	cursor: pointer;
`,u=o.span`
	font-size: 12px;
	color: ${({theme:o})=>o.text.text};
`;o.div`
	cursor: pointer;
	background-color: rgba(0, 0, 0, 0.1);
	min-height: 180px;
`;const v=o.div`
	border: 0.3px solid ${({theme:o})=>o.border.black10};
	border-radius: 3px;
`;o.div`
	width: ${({width:o})=>o};
	height: ${({height:o})=>o};
	overflow: "hidden";
	cursor: "pointer";
`,o.div`
	transform: ${({scale:o})=>`scale(${o})`};
	transform-origin: top left;
	width: ${({width:o})=>o};
	pointer-events: none;
`;const y=o.div`
	width: 24px;
	height: 24px;
	display: grid;
	place-content: center;
	position: absolute;
	box-shadow: 0 8px 12px 0 rgba(9, 30, 66, 0.15);
	border-radius: 9999px;
	border: 0.5px solid rgba(0, 0, 0, 0.1);
	right: -13px;
	background-color: ${({theme:o})=>o.bg.primary};
	cursor: pointer;
`;export{r as BlockContainer,p as BlockOrderNumber,n as BlockPreviewContainer,t as BlocksContainer,i as ButtonContentContainer,y as CloseButtonContainer,m as GroupTemplateButton,f as GroupTemplateButtonContainer,h as GroupTemplateContainer,u as GroupTemplateName,v as GroupTemplatePreviewContainer,b as GroupTemplatesContainer,e as SidebarContainer,x as TemplatesBackButton,s as TemplatesContainer,d as TemplatesGroupContainer,a as TemplatesGroupHeader,g as TemplatesGroupsContainer,c as TemplatesGroupsHeading,l as TemplatesHeading};
